var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"dd-m-modal--payment"},[_c('LogoIcon',{attrs:{"width":"32"}}),_c('p',[_c('strong',[_vm._v("Aguarde,")]),_vm._v(" enquanto processamos "),_c('br'),_vm._v("seu pagamento. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }